<template>
  <div class="apparea">
    <section class="flight_only_area vh-100" v-if="isLoading">
      <ContentLoading type="product" />
    </section>
    <section class="flight_only_area" v-else>
      <!----- header area start ----->
      <header class="header-area">
        <div class="container">
          <div class="d-flex justify-content-center">
            <figure class="logo bonauf-app-logo" @click="gotoHome"><img :src="`${speedSizeDomain}/assets/img/app/logo.png`" alt="#" title="" /></figure>
            <button class="btn-close pr-2"  @click="gotoDealFilterPage">
              <i class="fa-solid fa-chevron-right ml-5"></i>
            </button>
          </div>
        </div>
      </header>
      <!----- header area stop ----->
      <main class="body_warrper" ref="flight">

        <!------ trust signals strip start ------>
        <section class="trust-signals-section">
          <div class="container">
            <div class="trust-signals" aria-label="trust">
              <span class="trust-item"><i class="fas fa-lock"></i> תשלום מאובטח SSL</span>
              <span class="trust-item"><i class="fas fa-shield-alt"></i> פרטיות מוגנת</span>
              <span class="trust-item"><i class="fas fa-headset"></i> תמיכה טלפונית</span>
            </div>
          </div>
        </section>
        <!------ trust signals strip stop ------>

        <!------ plaindetails area start ------->
        <div v-if="!availableFlight">
          <section class="plaindetails-area">
            <div class="container">
              <div class="plaindetails-box">
                <h5>{{ $t("flight-only.unavailable-flight") }}</h5>
              </div>
            </div>
          </section>
        </div>
        <flight-box-one-app
          type="depature"
          :baggagePriceInfo="baggagePriceInfo"
          :data="departureItem"
          :airInfo="airInfoDepart"
        />
        <flight-box-one-app
          type="return"
          :baggagePriceInfo="baggagePriceInfo"
          :data="returnItem"
          :airInfo="airInfoReturn"
        />
        <!------ plaindetails area stop ------->
        <section class="plaindetails-area">
          <div class="container" v-if="extraFlights.length>0">
            <div class="select-flight d-flex bnf-select-flight"  v-if="extraFlights.length>1">
              <div class="selectflhtbtn m-auto btn-primary bnf-flight-toggle-btn" id="selectflhtbtn" v-b-toggle="`filter-content`" role="button" tabindex="0">
                <img class="bnf-toggle-icon-img" :src="`${speedSizeDomain}/assets/img/flight.png`" alt="" />
                <span class="bnf-toggle-text">{{ $t('product-page.more-flight-option') }}</span>
              </div>
            </div>
            <b-collapse class="filter-cont dVacation-pack" :id="`filter-content`" v-model="visibleMoreFlights">
              <flight-item-app
                v-for="(item, inx) in extraFlights"
                :key="inx"
                :flight="item"
                :baggagePriceInfo="baggagePriceInfo"
                :idx="inx"
                :selectIdx="idxFlight"
                categoryName="Flight_Only"
                type="product"
                @change="changeFlightIndex"
              />
            </b-collapse>
          </div>
        </section>
        <!------ general terms accordion (R5 B28 — flight-only static terms) ------>
        <section class="bnf-fo-terms-section">
          <div class="container">
            <button
              type="button"
              class="bnf-fo-terms-toggle"
              :aria-expanded="termsOpen ? 'true' : 'false'"
              aria-controls="bnf-fo-terms-content"
              @click="termsOpen = !termsOpen"
            >
              <span class="bnf-fo-terms-toggle-text">
                <i class="fas fa-file-contract" aria-hidden="true"></i>
                תנאים כלליים
              </span>
              <i :class="['fas', termsOpen ? 'fa-chevron-up' : 'fa-chevron-down', 'bnf-fo-terms-chevron']" aria-hidden="true"></i>
            </button>
            <b-collapse id="bnf-fo-terms-content" v-model="termsOpen">
              <ul class="bnf-general-terms-list">
                <li v-for="(term, idx) in flightOnlyTerms" :key="idx" v-html="term"></li>
              </ul>
            </b-collapse>
          </div>
        </section>
        <!------ general terms stop ------>

        <!------ payment area start ------>
        <section class="paymentbox-area">
            <div class="container">
                <h6>{{ $t("booking.payment") }}</h6>
            </div>
        </section>
        <!------ payment area stop ------>
        <flight-box-three-app :product="product" :airInfo="airInfoDepart"/>
      </main>
    </section>
  </div>
</template>

<script>
import { VBToggle, BCollapse } from 'bootstrap-vue';
import TemplateFlightOnly from './TemplateFlightOnly';

export default {
  name: 'FlightOnlyApp',
  components: {
    // BCollapse,
    ContentLoading: () => import('@/components/atoms/ContentLoading'),
    FlightBoxOneApp: () => import('@/components/flightOnly/FlightBoxOneApp'),
    FlightBoxThreeApp: () => import('@/components/flightOnly/FlightBoxThreeApp'),
    FlightItemApp: () => import('@/components/atoms/FlightItemApp'),
    BCollapse,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  extends: TemplateFlightOnly,
  data() {
    return {
      termsOpen: false,
    };
  },
  computed: {
    /* R5 B28: pull static flight-only terms from i18n (mirrors flying.co.il) */
    flightOnlyTerms() {
      const list = this.$t('product-page.default-general-terms.flights');
      return Array.isArray(list) ? list : [];
    },
  },
  methods: {
    gotoHome() {
      this.$router.push('/');
    },
    setFlightOfProduct() {
      this.product.discounted = 0;
      this.product.discountPercent = 0;
      this.product.category = this.category;

      const activeFlight = this.extraFlights[this.idxFlight];
      if (!activeFlight) return;
      const OFObject = activeFlight.FlightDetail[0], IFObject = activeFlight.FlightDetail[1];
      const outwardFlight = {
          flightId: OFObject.FL_ID,
          departureCityCode: OFObject.FL_From_Air_Port,
          departureDate: OFObject.FL_Date,
          departureTime: OFObject.FL_Dep_Hour,
          arrivalCity: OFObject.FL_To_Air_Port,
          class: activeFlight.Class1,
          paxIds: [],
        },
        inwardFlight = {
          flightId: IFObject.FL_ID,
          departureCityCode: IFObject.FL_From_Air_Port,
          departureDate: IFObject.FL_Date,
          departureTime: IFObject.FL_Dep_Hour,
          arrivalCity: IFObject.FL_To_Air_Port,
          class: activeFlight.Class2,
          paxIds: [],
        };
      this.product.outwardFlight = outwardFlight;
      this.product.inwardFlight = inwardFlight;

      let barCode = activeFlight.FlightDetail[0].FL_AIRLINE;
      if (this.product.airlineInfo && this.product.airlineInfo[barCode]) this.airInfoDepart = this.product.airlineInfo[barCode];

      barCode = activeFlight.FlightDetail[1].FL_AIRLINE;
      if (this.product.airlineInfo && this.product.airlineInfo[barCode]) this.airInfoReturn = this.product.airlineInfo[barCode];

      activeFlight.FlightDetail[0].airlineInfo = this.airInfoDepart;
      activeFlight.FlightDetail[1].airlineInfo = this.airInfoReturn;
      this.product.flights = [activeFlight];
      // this.product.packSelectionId = this.packSelectionId;

      this.product.flights.forEach((itemFlight) => {
        itemFlight.translations = this.product.translations;
      });

      this.departureItem = activeFlight.FlightDetail[0];
      this.departureItem.translations = this.product.translations;
      this.returnItem = activeFlight.FlightDetail[1];
      this.returnItem.translations = this.product.translations;

      window.sessionStorage.setItem('production', JSON.stringify(this.product));
    },
    gotoDealFilterPage() {
      this.$router.push(`/deal-filter/app?channel=App`);
    },
  },
};
</script>

<style>
  .productPage .btnDomestic {display:none !important;}
</style>

<style scoped>
/* ===== Trust signals strip on flight-only page ===== */
.trust-signals-section {
  padding: 8px 0;
}
.trust-signals-section .trust-signals {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 14px;
  padding: 10px 14px;
  margin: 4px auto 12px;
  background: #f7faff;
  border: 1px solid #e1e9f5;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #2d4a6b;
  max-width: 720px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}
.trust-signals-section .trust-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.trust-signals-section .trust-item i {
  color: #28a745;
  font-size: 13px;
}

/* ===== "More flight options" — secondary button (mirrors product page) ===== */
.bnf-select-flight {
  margin: 16px 0 8px;
}
.bnf-flight-toggle-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 18px;
  background: #ffffff !important;
  color: #1c4e80 !important;
  border: 1.5px solid #1c4e80 !important;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  min-height: 42px;
  text-align: center;
}
.bnf-flight-toggle-btn:hover,
.bnf-flight-toggle-btn:focus {
  background: #eff6ff !important;
  box-shadow: 0 2px 6px rgba(28, 78, 128, 0.12);
  outline: none;
}
.bnf-flight-toggle-btn .bnf-toggle-icon-img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  flex: 0 0 18px;
}
.bnf-flight-toggle-btn .bnf-toggle-text {
  display: inline-block;
  flex: 0 1 auto;
  text-align: center;
  line-height: 1.2;
}

@media (max-width: 479px) {
  .trust-signals-section .trust-signals {
    font-size: 11px;
    gap: 8px;
    padding: 8px 10px;
    margin: 4px 8px 10px;
  }
  .trust-signals-section .trust-item i {
    font-size: 11px;
  }
  .bnf-flight-toggle-btn {
    width: 100%;
    max-width: 320px;
  }
}
</style>
